import { Component, input, output } from '@angular/core';

@Component({
  selector: 'eiq-card',
  templateUrl: 'card.component.html',
  styleUrls: ['card.component.scss', '_card-theme.component.scss']
})
export class CardComponent {
  clickable = input<boolean>(false);
  disabled = input<boolean>(false);
  headerStyle = input<'inline' | 'spaced' | 'column'>('spaced');
  noContent = input<boolean>(false);
  shadow = input<boolean>(false);
  style = input<'light' | 'medium' | 'dark' | 'transparent' | 'warn' | 'alert' | 'primary' | 'success'>('medium');
  testId = input<string>();
  title = input<string>();
  titleStyle = input<'link' | 'default'>('default');

  clicked = output<void>();
}
